import React from "react";

import connect from "../i18n/connect";
import {
  finalizePaymentNativeRoutine,
  finalizePaymentRoutine
} from "../redux/modules/payment";
import { getPaymentFormLoading } from "../redux/modules/payment/selector";
import { fetchOffersRoutine } from "../redux/modules/plans";
import { getOffers } from "../redux/modules/plans/selector";

export default function withPlans(WrappedComponent) {
  const mapStateToProps = state => ({
    offers: getOffers(state),
    paymentFormLoading: getPaymentFormLoading(state)
  });

  const mapDispatchToProps = {
    finalizePayment: finalizePaymentRoutine,
    finalizePaymentNative: finalizePaymentNativeRoutine,
    fetchOffers: fetchOffersRoutine
  };

  @connect(mapStateToProps, mapDispatchToProps)
  class WithPlans extends React.Component {
    componentDidMount() {
      const { fetchOffers } = this.props;

      fetchOffers();
    }

    render() {
      return <WrappedComponent {...this.props} />;
    }
  }

  return WithPlans;
}
